import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    OrderCancel,
    OrderCancelActionTypes,
    OrderCancelFailure,
    OrderCancelSuccess
} from './actions';
import { OrderCancelService } from './service';
import { ErrorWrapper, getErrorText } from '@trade-platform/ui-shared';
import { cancelRefusalText } from '../../utils';

@Injectable()
export class OrderCancelEffects {
    private actions$ = inject(Actions);
    private orderCancelService = inject(OrderCancelService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderCancel$ = createEffect(() =>
        this.actions$.pipe(
            ofType<OrderCancel>(OrderCancelActionTypes.ORDER_CANCEL),
            switchMap(action =>
                this.orderCancelService.orderCancel(action.payload.orderId).pipe(
                    map(_ => new OrderCancelSuccess()),
                    catchError<Action, Observable<Action>>((error: string | HttpErrorResponse) => {
                        let wrapped: ErrorWrapper;
                        if (error instanceof HttpErrorResponse) {
                            const refusalText = cancelRefusalText(error);
                            wrapped = new ErrorWrapper(error.message, {
                                errorText: getErrorText(error),
                                status: error.status,
                                ...(refusalText ? { refusalText } : {})
                            });
                        } else {
                            wrapped = new ErrorWrapper(error);
                        }

                        return of(new OrderCancelFailure({ error: wrapped }));
                    })
                )
            )
        )
    );
}
